import { render, staticRenderFns } from "./ItemActive.vue?vue&type=template&id=7606b6b3&"
import script from "./ItemActive.vue?vue&type=script&lang=js&"
export * from "./ItemActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports